import { render, staticRenderFns } from "./AllotRole.vue?vue&type=template&id=45dd29c1&scoped=true&"
import script from "./AllotRole.vue?vue&type=script&lang=js&"
export * from "./AllotRole.vue?vue&type=script&lang=js&"
import style0 from "./AllotRole.vue?vue&type=style&index=0&id=45dd29c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd29c1",
  null
  
)

export default component.exports